document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener(
    "submit",
    async (e) => {
      const form = e.target;

      if (!form.matches('form[data-type="add-to-cart-form"]')) return;

      const series = form.querySelector('input[name="properties[_series]"]')?.value;

      if (!series) return;

      const res = await fetch("/cart.js");
      const cart = await res.json();

      const exists = cart.items.some((item) => {
        return item.properties && item.properties._series === series;
      });

      if (exists) {
        e.preventDefault();
        e.stopImmediatePropagation();

        alert("同じシリーズの商品は同時に購入できません。また、同一商品は複数点ご購入いただけません。");
      }
    },
    true // ← capture
  );
});

/* カート内の商品削除後の動作 */
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  let previousHTML = drawer.innerHTML;

  const observer = new MutationObserver(() => {
    const currentHTML = drawer.innerHTML;

    // ドロワーが更新された＝削除 or 更新が走った
    if (previousHTML !== currentHTML) {
      previousHTML = currentHTML;

      // リロードフラグがあればリロード
      if (sessionStorage.getItem('cart_reload')) {
        sessionStorage.removeItem('cart_reload');
        location.reload();
      }
    }
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true,
  });

  // 削除ボタン押下だけはフックできる（これは補助）
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cart-remove-button');
    if (!btn) return;

    sessionStorage.setItem('cart_reload', '1');
  });
})();